import { For, Show, type JSX } from 'solid-js'
import Css from './table.module.scss'

/**
 * O paginador.
 *
 * A janela de paginas vem PRONTA do scope (`pageWindow`): quantas mostrar e como
 * centrar na atual e regra de dominio, e ja esta testada la. Aqui so se desenha o
 * que chegou.
 */
export function Pager(props: {
    page: number
    pageCount: number
    pages: readonly number[]
    total?: number
    onPrevious: () => void
    onNext: () => void
    onGoTo: (page: number) => void
}): JSX.Element {
    return (
        <Show when={props.pageCount > 1}>
            <div class={Css.pager}>
                <p class={Css.count}>
                    Página {props.page} de {props.pageCount}
                    <Show when={props.total}>{(total) => <> · {total()} no total</>}</Show>
                </p>

                <div class={Css.pages}>
                    <Step label="Página anterior" disabled={props.page <= 1} onClick={props.onPrevious}>
                        <path d="m15 18-6-6 6-6" />
                    </Step>

                    <For each={props.pages}>
                        {(page) => (
                            <button
                                type="button"
                                onClick={() => props.onGoTo(page)}
                                aria-current={page === props.page ? 'page' : undefined}
                                class={Css.page}
                                classList={{ [Css.current]: page === props.page }}
                            >
                                {page}
                            </button>
                        )}
                    </For>

                    <Step label="Próxima página" disabled={props.page >= props.pageCount} onClick={props.onNext}>
                        <path d="m9 18 6-6-6-6" />
                    </Step>
                </div>
            </div>
        </Show>
    )
}

function Step(props: { label: string; disabled: boolean; onClick: () => void; children: JSX.Element }): JSX.Element {
    return (
        <button
            type="button"
            aria-label={props.label}
            disabled={props.disabled}
            onClick={props.onClick}
            class={Css.step}
        >
            <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            >
                {props.children}
            </svg>
        </button>
    )
}
